import React, { useEffect, useState } from "react";
import SidebarLayout from "../../../common/sidebar/SidebarLayout";
import { Helmet } from "react-helmet";
import { ReactComponent as DownloadIcon } from "../../../../assets/icons/TestAccounts.svg";
import OPSPrimaryHeader from "../../../common/primaryHeader/OPSPrimaryHeader";
import OverdueInvoicesDataTable from "./OverdueInvoicesDataTable";
import { useSelector } from "react-redux";
import { fetchClinicGroupInvoices } from "../../../../store/features/ops/opsSlice";
import PatientLoader from "../../../common/PatientLoader";
const OverdueInvoices = () => {
  const { opsLoading, healthcareGroups } = useSelector((state) => state.ops);
  const [pendingInvoices, setPendingInvoices] = useState([]);
  const [localLoading, setLocalLoading] = useState(true);

  const onSuccess = ({ data }, item) => {
    let thirtyDays = 0;
    let sixtyDays = 0;

    if (data) {
      data.forEach((x) => {
        const d1 = new Date();
        const d2 = new Date(x.due_date * 1000);
        const diff = d1.getTime() - d2.getTime();
        const daydiff = diff / (1000 * 60 * 60 * 24);

        if ((x?.status === "open" || x?.status === "draft") && daydiff >= 30)
          thirtyDays += 1;
        if ((x?.status === "open" || x?.status === "draft") && daydiff >= 60)
          sixtyDays += 1;
      });
    }
    const temp = JSON.parse(JSON.stringify(item));
    temp["thirty"] = thirtyDays;
    temp["sixty"] = sixtyDays;
    temp["shouldShow"] = Boolean(thirtyDays + sixtyDays);
    return temp;
  };

  function getOnlyPending() {
    let temp = [];
    if (!opsLoading) {
      if (healthcareGroups?.length > 0) {
        healthcareGroups.forEach((item) => {
          if (item?.invoicing) {
            fetchClinicGroupInvoices({
              clinic_group_id: item?.id,
              limit: 50,
            })
              .then((res) => {
                const dueInvoices = onSuccess(res.data, item);
                if (dueInvoices?.shouldShow === true) {
                  temp.push(dueInvoices);
                }
              })
              .catch((e) => {
                console.log(e);
              });
          }
        });
      }
    }
    return temp;
  }

  useEffect(() => {
    const onlyPending = getOnlyPending();
    setPendingInvoices(onlyPending);
    setLocalLoading(false);
  }, [localLoading]);

  return (
    <SidebarLayout>
      <section className="contianer-fluid px-5 py-2">
        <Helmet>
          <meta charSet="utf-8" />
          <title>Overdue Invoices | Rose Health</title>
          <link rel="canonical" href={window.location.origin} />
        </Helmet>
        <div
          className="container-fluid px-3 d-flex justify-content-between"
          style={{ alignContent: "center", alignItems: "center" }}
        >
          <OPSPrimaryHeader
            titleText={`Overdue Invoices`}
            showSubtitle={false}
            showButton={false}
            showPill={false}
          />
          <button className="primary-btn d-flex" style={{ gap: "10px" }}>
            <DownloadIcon /> Download
          </button>
        </div>
        {localLoading || opsLoading ? (
          <PatientLoader />
        ) : (
          <OverdueInvoicesDataTable
            loading={localLoading && opsLoading}
            data={pendingInvoices}
          />
        )}
      </section>
    </SidebarLayout>
  );
};

export default OverdueInvoices;
